import { render } from "./Building.vue?vue&type=template&id=3b59ec42&scoped=true"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"

import "./Building.vue?vue&type=style&index=0&id=3b59ec42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b59ec42"]])

export default __exports__